import {IconButton, IconButtonProps, Tooltip} from 'platform/components';

import {omit} from 'ramda';

interface SourcingActionButtonProps extends IconButtonProps {
  label: string;
  hasUnifiedSurfaces: boolean;
}

export function SourcingActionButton(props: SourcingActionButtonProps) {
  const buttonProps = omit(['label', 'hasUnifiedSurfaces'], props);
  if (!props.hasUnifiedSurfaces) {
    return <IconButton {...buttonProps} />;
  }
  return (
    <Tooltip label={props.label}>
      <IconButton {...buttonProps} aria-label={props.label} />
    </Tooltip>
  );
}
